<div class="td-card td-health-card">
  <span class="td-card-title">{{ 'td_team_report_health_score' | translate }}</span>

  <ng-container *ngIf="data; else noData">
    <div class="td-health-gauge">
      <app-gauge-display
        [value]="data.score"
        [width]="180"
        [height]="155"
        [isOnTeamCodex]="true"
        [colorStart]="data.color"
        [colorEnd]="data.color"
        [backgroundColor]="'#E7EBF8'">
      </app-gauge-display>
    </div>

    <div class="td-health-stats">
      <div class="td-health-stat">
        <span class="td-health-stat-icon" [ngClass]="data.trend ? data.trend : 'flat'">
          <img *ngIf="data.trend" [src]="'../../../assets/svg/indicator-arrow-' + data.trend + '.svg'" alt="">
          <i class="bi bi-dash-lg" *ngIf="!data.trend"></i>
        </span>
        <div class="td-health-stat-text">
          <span class="td-health-stat-value">{{ data.diff !== null ? (data.diff + '%') : '-' }}</span>
          <span class="td-health-stat-label">{{ 'td_overall_score_change' | translate }}</span>
        </div>
      </div>

      <div class="td-health-stat">
        <span class="td-health-stat-icon response">
          <i class="bi bi-arrow-left-right"></i>
        </span>
        <div class="td-health-stat-text">
          <span class="td-health-stat-value">{{ data.responseRate }}%</span>
          <span class="td-health-stat-label">{{ 'td_team_report_response_rate' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="td-health-vs">
      <span class="td-health-vs-title">{{ 'td_team_report_vs_workspace' | translate }}</span>

      <div class="td-health-vs-row">
        <div class="td-health-vs-top">
          <span class="td-health-vs-legend">
            <i class="td-health-vs-dot team"></i>
            <span>{{ 'td_team_report_team' | translate }}</span>
          </span>
          <span class="td-health-vs-value">{{ data.score }}%</span>
        </div>
        <div class="td-health-vs-track">
          <i class="td-health-vs-fill team" [ngStyle]="teamBarStyle"></i>
        </div>
      </div>

      <div class="td-health-vs-row">
        <div class="td-health-vs-top">
          <span class="td-health-vs-legend">
            <i class="td-health-vs-dot workspace"></i>
            <span>{{ 'td_team_report_workspace' | translate }}</span>
          </span>
          <span class="td-health-vs-value">
            {{ data.workspaceScore !== null ? (data.workspaceScore + '%') : '-' }}
          </span>
        </div>
        <div class="td-health-vs-track">
          <i class="td-health-vs-fill workspace" [ngStyle]="workspaceBarStyle"></i>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noData>
    <span class="td-health-empty">{{ 'td_no_data' | translate }}</span>
  </ng-template>
</div>
